'use strict';

var bind = require('function-bind');

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);



// WEBPACK FOOTER //
// webpack:///node_modules/has/src/index.js